<h2 mat-dialog-title class="text-center mb-1" [class.text-danger]="data.destructive">{{ data.dialogTitle | translate }}</h2>
<div mat-dialog-content *ngIf="data.dialogMessage" class="text-center">
  <p class="mb-0">{{ data.dialogMessage | translate }}</p>
</div>
<mat-dialog-actions class="d-flex flex-row justify-content-center">
  <ng-container *ngIf="data.destructive; else defaultActions">
    <button mat-button mat-dialog-close (click)="cancel()" class="btn btn-outline-primary btn-sm">{{ data.cancelButtonName | translate }}</button>
    <button mat-button (click)="confirm()" class="btn btn-danger btn-sm">{{ data.confirmButtonName | translate }}</button>
  </ng-container>
  <ng-template #defaultActions>
    <button mat-button (click)="confirm()" class="btn btn-outline-primary btn-sm">{{ data.confirmButtonName | translate }}</button>
    <button mat-button mat-dialog-close (click)="cancel()" class="btn btn-outline-secondary btn-sm">{{ data.cancelButtonName | translate }}</button>
  </ng-template>
</mat-dialog-actions>
